import { css } from '@emotion/core';
/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { DropdownItem } from '@atlaskit/dropdown-menu';
import { gridSize } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const FilterModeSelectorContainer = styled.div({
  padding: `0 ${gridSize() / 2}px`,
});

export const FilterModeSelectorSeparator = styled.div({
  position: 'relative',
  '&::before': {
    content: "''",
    position: 'absolute',
    top: '50%',
    height: `${gridSize() * 3}px`,
    transform: 'translateY(-50%)',
    width: '1px',
    right: 0,
    background: token('color.background.input'),
  },
});

export const FilterModeSelectorTriggerContainer = styled.div({
  minWidth: '76px',
  button: {
    paddingLeft: 0,
    paddingRight: 0,
  },
});

const selectedOptionStyles = css({
  background: token('color.background.neutral.bold'),
  color: token('color.text.inverse'),
});

// Add styles to the selected DropdownItem manually because the native isSelected prop doesn't apply styles
// when the item is selected
export const FilterOptionWrapper = styled(DropdownItem)<{
  isSelected: boolean;
}>(props => ({
  '&&&': props.isSelected && selectedOptionStyles,
}));
